/**
 * converts mi/h to km/h
 * @param {} milesperhour
 * @returns {}
 */
export function convertMiPerHourToKmPerHour(miles) {
    if (miles === 0) {
        return 0;
    }
    var mi = parseFloat(miles);
    var km = "";
    if (!isNaN(mi)) km = mi * 1.609344;
    if (km) {
        return km.toFixed(2);
    }
    return 0;
}

/**
 * converts  km/h to mi/h
 * @param {} km per hour
 * @returns {}
 */
export function convertKmPerHourToMiPerHour(input) {
    if (input === 0) {
        return 0;
    }
    var km = parseFloat(input);
    var ret = "";
    if (!isNaN(km)) ret = km / 1.609344;
    if (ret) {
        return ret.toFixed(2);
    }
    return 0;
}


/**
 * converts  cm/s to km/h
 * @param {} km per hour
 * @returns {}
 */
export function convertCmPerSecondToKmPerHour(input) {
    if (input === 0) {
        return 0;
    }
    var cms = parseFloat(input);
    var ret = "";
    if (!isNaN(cms)) ret = cms * 0.036;
    if (ret) {
        return ret.toFixed(2);
    }
    return 0;
}

/**
 * converts  cm/s to mph
 * @param {} km per hour
 * @returns {}
 */
export function convertCmPerSecondToMilePerHour(input) {
    if (input === 0) {
        return 0;
    }
    var cms = parseFloat(input);
    var ret = "";
    if (!isNaN(cms)) ret = cms * 0.0223694;
    if (ret) {
        return ret.toFixed(2);
    }
    return 0;
}



// WEBPACK FOOTER //
// ./src/services/systemOfUnitsServices.js